const SwatchFragment = (
  /* GraphQL */
  `
  fragment Swatch on Swatch {
    __typename
    id
    hue
    saturation
    lightness
  }
`
);
const FileFragment = (
  /* GraphQL */
  `
  fragment File on File {
    __typename
    id
    name
    publicUrl: publicUrlV2
    extension
    dimensions {
      width
      height
    }
  }
`
);
const TypographyFragment = (
  /* GraphQL */
  `
  fragment Typography on Typography {
    __typename
    id
    name
    style {
      deviceId
      value {
        fontFamily
        fontSize {
          value
          unit
        }
        color {
          swatchId
          alpha
        }
        lineHeight
        letterSpacing
        fontWeight
        textAlign
        uppercase
        underline
        strikethrough
        italic
      }
    }
  }
`
);
const PagePathnameSliceFragment = (
  /* GraphQL */
  `
  fragment PagePathnameSlice on PagePathnameSlice {
    __typename
    id
    pathname
  }
`
);
const GlobalElementFragment = (
  /* GraphQL */
  `
  fragment GlobalElement on GlobalElement {
    __typename
    id
    data
  }
`
);
const LocalizedGlobalElementFragment = (
  /* GraphQL */
  `
  fragment LocalizedGlobalElement on LocalizedGlobalElement {
    __typename
    id
    data
  }
`
);
const TableFragment = (
  /* GraphQL */
  `
  fragment Table on Table {
    __typename
    id
    name
    columns {
      __typename
      id
      name

      ... on MultipleSelectTableColumn {
        options {
          id
          name
        }
      }

      ... on SingleSelectTableColumn {
        options {
          id
          name
        }
      }
    }
  }
`
);
const SnippetFragment = (
  /* GraphQL */
  `
  fragment Snippet on Snippet {
    __typename
    id
    name
    code
    cleanup
    location
    shouldAddToNewPages
    liveEnabled
    builderEnabled
  }
`
);
const PageFragment = (
  /* GraphQL */
  `
  fragment Page on Page {
    __typename
    id
    snippets {
      __typename
      id
      name
      code
      cleanup
      location
      shouldAddToNewPages
      liveEnabled
      builderEnabled
    }
  }
`
);
const SiteFragment = (
  /* GraphQL */
  `
  fragment Site on Site {
    __typename
    id
    googleFonts {
      edges {
        activeVariants {
          specifier
        }
        node {
          family
          variants {
            specifier
          }
        }
      }
    }
  }
`
);
export {
  FileFragment,
  GlobalElementFragment,
  LocalizedGlobalElementFragment,
  PageFragment,
  PagePathnameSliceFragment,
  SiteFragment,
  SnippetFragment,
  SwatchFragment,
  TableFragment,
  TypographyFragment
};
//# sourceMappingURL=fragments.js.map